import React, { useState } from "react";
import {
  Sparkles,
  PanelLeftClose,
  Plus,
  Search,
  History,
  UserCircle,
  FileText,
  Database,
} from "lucide-react";
import "./../../../../assets/css/student/AITutorLayout/AITutorSidebar/AITutorSidebar.css";

const NAV_ITEMS = [
  { icon: Search, label: "Search Sessions", tip: "Search" },
  { icon: FileText, label: "Learning Context", tip: "Context" },
  { icon: Database, label: "AI Memory", tip: "Memory" },
];

const AITutorSidebar = ({ mode = "tutor", onNewSession }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen((p) => !p);

  const modeLabel = mode === "tutor" ? "Tutor" : "Buddy";

  return (
    <aside
      className={`tcs-sidebar mode--${mode} ${isOpen ? "is-open" : "is-closed"}`}
      aria-label="Techify AI sidebar"
    >
      {/* ── Brand ── */}
      <div className="tcs-brand">
        <div className="tcs-tooltip-wrap" data-tip="Techify AI">
          <button
            className="tcs-brand-btn"
            onClick={toggle}
            aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
          >
            <Sparkles size={14} />
          </button>
        </div>

        {isOpen && <span className="tcs-brand-name">Techify AI</span>}
        {isOpen && <span className="tcs-brand-mode">{modeLabel}</span>}

        {isOpen && (
          <button
            className="tcs-icon-btn"
            onClick={toggle}
            aria-label="Collapse"
          >
            <PanelLeftClose size={14} />
          </button>
        )}
      </div>

      {/* ── New session CTA ── */}
      <div className="tcs-top">
        <div className="tcs-tooltip-wrap" data-tip="New Session">
          <button
            className="tcs-new-btn"
            onClick={onNewSession}
            aria-label="Start new session"
          >
            <Plus size={13} />
            {isOpen && <span>Start New Session</span>}
          </button>
        </div>
      </div>

      {/* ── Workspace nav ── */}
      <nav className="tcs-nav" aria-label="Workspace">
        {isOpen && <p className="tcs-group-label">Workspace</p>}
        {NAV_ITEMS.map(({ icon: Icon, label, tip }) => (
          <div key={label} className="tcs-tooltip-wrap" data-tip={tip}>
            <button className="tcs-nav-btn" aria-label={label}>
              <Icon size={13} />
              {isOpen && <span>{label}</span>}
            </button>
          </div>
        ))}
      </nav>

      <div className="tcs-divider" />

      {/* ── History ── */}
      {isOpen && (
        <div className="tcs-history">
          <p className="tcs-group-label">
            <History size={11} />
            Recent Sessions
          </p>
          <p className="tcs-history-empty">No sessions yet</p>
        </div>
      )}

      {/* ── Account footer ── */}
      <div className="tcs-footer">
        <div className="tcs-tooltip-wrap" data-tip="Account">
          <button className="tcs-account-btn" aria-label="Account">
            <div className="tcs-account-avatar">
              <UserCircle size={15} />
            </div>
            {isOpen && (
              <div className="tcs-account-meta">
                <span className="tcs-account-name">Student</span>
                <span className="tcs-account-plan">Free plan</span>
              </div>
            )}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AITutorSidebar;
